export const initialBonificacionFilters = {
  search: "",
  estado: "all",
  fecha_desde: "",
  fecha_hasta: "",
};

export const estadosBonificacionOptions = [
  { value: "pendiente", label: "Pendiente" },
  { value: "pagada", label: "Pagada" },
  { value: "no_pagada", label: "No Pagada" },
  { value: "anulada", label: "Anulada" },
];

export const estadosPendientesOptions = [
  { value: "pendiente", label: "Pendiente" },
  { value: "no_pagada", label: "No Pagada" },
  { value: "anulada", label: "Anulada" },
];
